import { INSURANCE_NAME_VALUE } from "Store/interfaces/products/";
import { BaseStbRiskProduct } from "./BaseStbRiskProduct";

export interface AnimalProduct extends BaseStbRiskProduct {
  readonly name: INSURANCE_NAME_VALUE.ANIMAL;
  readonly species: Species;
  readonly breed: string;
  readonly breedRatingParameter?: string;
  readonly animalName: string;
  readonly microchipped: boolean;
  readonly coverageAmountDeath: number;
  readonly coverageAmountVet: number;
  readonly dateOfBirth: string;
}

export enum Species {
  DOG = "dog",
  CAT = "cat",
}
